module.exports = __webpack_public_path__ + "static/media/react.13b7c021.png";